<ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>

<div class="content">
  <div class="call-header">
    <h2 class="call-name">
      {{ callStore.getCall()?.callName }}
    </h2>
    <div class="session-content"></div>
    <!-- Tooltip copy session id -->
    <quant-tooltip content="Session ID copied!" arrow="top">
      <div class="session-id" (click)="copyToClipboard()">
        <span> {{'call.SESSION_ID_LABEL' | transloco}} {{ callStore.getCall()?.practiceCallUuid }} </span>
        <img src="assets/icons/qnt-copy.svg" alt="{{'call.COPY_ALT' | transloco}}" />
      </div>
    </quant-tooltip>
  </div>
  <div
    class="avatar-video-container"
    [class.default-portrait]="isPortrait && visualAidDisabled"
    [class.default-landscape]="!isPortrait && visualAidDisabled"
    [class.visual-aid-landscape]="!isPortrait && !visualAidDisabled"
    [class.visual-aid-portrait]="isPortrait && !visualAidDisabled"
  >
    <ng-container *ngTemplateOutlet="avatarvideonew"></ng-container>
  </div>
  <div>
    <app-error-display-banner
      *ngIf="displayErrorBanner"
      class="global-error-banner"
    ></app-error-display-banner>
    <ng-container *ngIf="visualAidDisabled; else visualAidUI">
      <ng-container *ngIf="!isPortrait; else portraitMode">
        <ng-container>
          <div class="landscape-container">
            <div
              id="user-container"
              class="user-container"
              [class.no-hints]="callStore.getHints() == ''"
              *ngIf="controlService"
              [class.tour-hint]="controlService.displayTourHint"
            >
              <ng-container *ngTemplateOutlet="hints"></ng-container>
              <ng-container *ngTemplateOutlet="userVideonew"></ng-container>
              <ng-container *ngTemplateOutlet="showVisualAidBtn"></ng-container>
            </div>
          </div>
          <div class="landscape-mode-captions">
            <ng-template *ngTemplateOutlet="captions"></ng-template>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #portraitMode>
        <div class="portrait-body">
          <div class="top-container"></div>
          <div class="bottom-container">
            >
            <div id="user-content">
              <div class="left-container">
                <ng-container *ngTemplateOutlet="userVideonew"></ng-container>
              </div>
              <div
                class="right-container"
                [class.no-hints]="callStore.getHints() == ''"
                *ngIf="controlService"
                [class.tour-hint]="controlService.displayTourHint"
              >
                <ng-container *ngTemplateOutlet="hints"></ng-container>
                <ng-container
                  *ngTemplateOutlet="showVisualAidBtn"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="portrait-caption">
          <ng-container *ngTemplateOutlet="captions"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <ng-template #visualAidUI>
    <div *ngIf="isPortrait; else landscape" class="portrait">
      <div class="visual-aid">
        <ng-container *ngTemplateOutlet="visualAidContainer"></ng-container>
      </div>
      <div class="controls-and-btn">
        <div class="controls">
          <ng-container *ngTemplateOutlet="controls"></ng-container>
          <ng-container *ngTemplateOutlet="hideVisualAidBtn"></ng-container>
        </div>
      </div>
      <div class="avatar-and-hints">
        <div class="left-container">
          <div class="avatar-video"></div>
        </div>
        <div class="right-container">
          <div class="hintss" [ngClass]="{'no-hints': callStore.getHints() == ''}">
            <ng-container *ngTemplateOutlet="hints"></ng-container>
          </div>
        </div>
      </div>
      <div class="captions">
        <ng-container *ngTemplateOutlet="captions"></ng-container>
      </div>
    </div>
    <ng-template #landscape>
      <div class="landscape">
        <div class="left-container">
          <div class="visual-aid">
            <ng-container *ngTemplateOutlet="visualAidContainer"></ng-container>
          </div>
          <div class="controls-and-btn">
            <div class="controls">
              <ng-container *ngTemplateOutlet="controls"></ng-container>
              <ng-container *ngTemplateOutlet="hideVisualAidBtn"></ng-container>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="hintss" [ngClass]="{'no-hints': callStore.getHints() == ''}">
            <ng-container *ngTemplateOutlet="hints"></ng-container>
          </div>
          <div class="captions">
            <ng-container *ngTemplateOutlet="captions"></ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>

<footer
  [class.continue-tour]="
    controlService?.displayTour && !controlService?.displayTourHint
  "
>
  <div
    class="overlay-item"
    *ngIf="controlService?.displayTour && !controlService?.displayTourHint"
  ></div>
  <div class="footer-content" *ngIf="controlService && playerService">
    <div class="left">
      <!-- Settings -->
      <div
        class="button-text"
        (click)="deviceSettingsService?.displayDeviceSettingsModal()"
        data-testId="setting-btn"
      >
        <quant-button
          type="button"
          label=""
          hierarchy="secondary-gray-dark"
          size="md"
          iconLeading="assets/icons/settings.svg"
        ></quant-button>
        <label>Settings</label>
      </div>

      <!-- Captions -->
      <div
        class="button-text"
        (click)="controlService.toggleCaptions()"
        data-testId="captions-btn"
      >
        <quant-button
          type="button"
          label=""
          [hierarchy]="
            controlService.isCaptionsOn
              ? 'secondary-gray-dark'
              : 'destructive-dark'
          "
          [iconLeading]="
            controlService.isCaptionsOn
              ? 'assets/icons/qnt-cc.svg'
              : 'assets/icons/qnt-cc-off.svg'
          "
          size="md"
        >
        </quant-button>
        <label>Captions</label>
      </div>
    </div>

    <div class="center">
      <div
        id="btn-continue"
        *ngIf="
          callStore.getAdvanceType() === advanceTypeManual &&
          !callStore.getIsCallComplete()
        "
        data-testId="continue-btn"
      >
        <!-- Continue green -->
        <quant-button
          *ngIf="
            (!callStore.getIsPaused() &&
              !callStore.getIsContinueButtonBlocked() &&
              (callStore.getSpeechTranscript().length != 0 ||
                callStore.getSpeechTranscriptPartial().length != 0)) ||
            controlService.displayTour
          "
          type="button"
          label="Continue"
          hierarchy="primary"
          size="lg"
          [disabled]="false"
          (click)="controlService.displayTour ? null : handleContinue()"
        >
        </quant-button>

        <!-- Continue dark -->
        <quant-button
          *ngIf="
            (callStore.getIsPaused()||
              callStore.getIsContinueButtonBlocked() ||
              (callStore.getSpeechTranscript()?.length === 0 &&
                callStore.getSpeechTranscriptPartial()?.length === 0)) &&
            !controlService.displayTour
          "
          type="button"
          label="Continue"
          hierarchy="primary-dark"
          size="lg"
          [disabled]="callStore.getIsAvatarSpeaking()"
          (click)="
            controlService.displayTour
              ? null
              : controlService.clickOpenNoResponse()
          "
        >
        </quant-button>
      </div>

      <div
        class="chronometer-line"
        *ngIf="
          callStore.getAdvanceType() === advanceTypeManual &&
          !callStore.getIsCallComplete()
        "
      ></div>
      <!-- Chronometer -->
      <div class="chronometer">
        <div class="chronometer-time">{{ controlService.timer }}</div>
      </div>

      <!-- Pause -->
      <quant-button
        type="button"
        [label]="callStore.getIsPaused()? 'Resume' : 'Pause'"
        hierarchy="secondary-gray-dark"
        [iconLeading]="
          callStore.getIsPaused()
            ? 'assets/icons/play-circle.svg'
            : 'assets/icons/pause-circle.svg'
        "
        size="md"
        (click)="handlePauseClick()"
      >
      </quant-button>
    </div>

    <div class="right">
      <!-- Mute -->
      <div class="button-text" data-testId="mute-btn">
        <quant-button
          type="button"
          label=""
          [hierarchy]="
            callStore.getIsMicOn() ? 'secondary-gray-dark' : 'destructive-dark'
          "
          [iconLeading]="
            callStore.getIsMicOn()
              ? 'assets/icons/microphone-01.svg'
              : 'assets/icons/microphone-off-01.svg'
          "
          [class.inactive]="!callStore.getIsMicOn()"
          size="md"
          (click)="handleMuteClick()"
        >
        </quant-button>
        <label>{{ callStore.getIsMicOn() ? "Mute" : "Unmute" }}</label>
      </div>

      <!-- Video -->
      <div
        class="button-text margin-extra"
        (click)="handleCameraClick()"
        data-testId="video-btn"
        [matTooltipDisabled]="!deviceSettingsService?.isCameraUnavailable"
        #tooltipUnavailable="matTooltip"
        matTooltipClass="unavailable-tooltip"
        [matTooltip]="('call.BROWSER_ACCESS_DENIED' | transloco)"
      >
        <quant-button
          type="button"
          label=""
          [hierarchy]="
            !controlService.isVideoOn ||
            deviceSettingsService?.isCameraUnavailable
              ? 'destructive-dark'
              : 'secondary-gray-dark'
          "
          [iconLeading]="
            !controlService.isVideoOn ||
            deviceSettingsService?.isCameraUnavailable
              ? 'assets/icons/video-recorder-off.svg'
              : 'assets/icons/video-recorder.svg'
          "
          [badge]="!!deviceSettingsService?.isCameraUnavailable"
          badgeIcon="assets/icons/alert-circle-red.svg"
          size="md"
        >
        </quant-button>
        <label>{{
            !controlService.isVideoOn ||
            deviceSettingsService?.isCameraUnavailable
              ? "Start"
              : "Stop"
          }}
          Video</label>
      </div>

      <!-- End call -->
      <quant-button
        type="button"
        label="End Call"
        hierarchy="destructive-dark"
        size="md"
        iconLeading="assets/icons/phone-call-02.svg"
        (click)="handleEndCallClick()"
      >
      </quant-button>
    </div>
  </div>
</footer>

<!-- Settings modal -->
<app-device-settings-modal
  *ngIf="deviceSettingsService?.displayModal"
  [deviceSettingsService]="deviceSettingsService"
  [controlService]="controlService"
></app-device-settings-modal>

<!-- End call early -->
<app-end-call-early
  *ngIf="controlService?.isEndCallTriggered && !this.callStore.getDisplayPostCall()"
  [controlService]="controlService"
  [playerService]="playerService"
></app-end-call-early>

<!-- End call succesful -->
<app-post-call
  *ngIf="this.callStore.getDisplayPostCall()"
  [controlService]="controlService"
></app-post-call>

<!-- No response detected -->
<app-no-response-detected
  *ngIf="callStore.getOpenNoResponseModal()"
  [controlService]="controlService"
  [playerService]="playerService"
  [deviceSettingsService]="deviceSettingsService"
></app-no-response-detected>

<!-- Pause modal -->
<app-call-pause
  *ngIf="
    controlService &&
    callStore.getIsPaused() &&
    !deviceSettingsService?.displayModal &&
    !controlService.isEndCallTriggered &&
    !callStore.getOpenNoResponseModal() &&
    !controlService.displayTour &&
    !controlService.displayTourHint
  "
  [control]="controlService"
  [player]="playerService"
  [deviceSettings]="deviceSettingsService"
></app-call-pause>

<!-- Tour -->
<app-call-tour
  *ngIf="controlService?.displayTour"
  [control]="controlService"
  [player]="playerService"
></app-call-tour>

<ng-template #hints>
  <div class="overlay-item" *ngIf="controlService?.displayTourHint"></div>
  <div
    class="hints-container"
    *ngIf="controlService && controlService.displayTourHint"
  >
    <div class="hints">
      <div class="hints-title">Hints & Suggestions</div>
      <div class="hint">
        Throughout your call, talking points and tips will appear here to help
        you improve your conversation.
      </div>
      <quant-button
        type="button"
        label="Start Call"
        hierarchy="primary"
        size="xs"
        [disabled]="false"
        (click)="startCallAfterTour()"
      >
      </quant-button>
    </div>
  </div>

  <div
    class="hints-container"
    *ngIf="callStore.getHints() != '' && !controlService?.displayTourHint"
  >
    <div class="hint-icon">
      <div class="circle"></div>
      <div class="circle sm"></div>
      <img src="assets/icons/lightbulb-blue.svg" alt="{{'call.HINTS_ALT' | transloco}}" />
    </div>
    <div class="hints">
      <div class="hints-title">Hint</div>
      <div class="hint">
        {{ callStore.getHints() }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #captions>
  <div class="cc-container" *ngIf="!this.callStore.getDisplayPostCall()">
    <div
      class="cc-content"
      *ngIf="controlService?.isCaptionsOn && playerService?.canPlayVideo"
    >
      <div class="icon">
        <img src="assets/icons/closed-caption.svg" alt="{{'call.CLOSE_CAPTIONS' | transloco}}" />
      </div>
      <div class="cc-avatar-speech">
        <div class="cc-avatar-name">{{ playerService?.avatarName }}:</div>
        {{ playerService?.avatarSpeech() }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #avatarvideonew>
  <div
    id="video-content"
    class="video-content"
    *ngIf="!this.callStore.getDisplayPostCall()"
  >
    <div id="videos" class="videos" id="videos">
      <div
        id="avatar-video"
        class="avatar-videos"
        [class.speaking-border]="
          !playerService?.isLoopActive &&
          !callStore.getIsPaused() &&
          playerService?.canPlayVideo &&
          playerService?.avatarOffsetHeight &&
          playerService?.avatarOffsetHeight != 150
        "
      >
        <ng-container *ngFor="let item of playerService?.practiceCallClips">
          <video
            class="video-element"
            [id]="'avatar-video-' + item.index"
            [src]="item.src"
            [className]="item.className"
            preload="auto"
            (canplay)="avatarVideoIsReady(item)"
            (error)="avatarLoadingError($event, item)"
          ></video>
        </ng-container>

        <div id="video-background" class="video-background">
          <video
            id="video-background-loop"
            preload="auto"
            [src]="playerService?.loopClipFilename"
            muted
          ></video>
        </div>
        <div id="video-top-elements">
          <div class="video-name">{{ playerService?.avatarName }}</div>
          <div id="video-status">
            <div
              class="video-status"
              *ngIf="
                !playerService?.isLoopActive &&
                !callStore.getIsPaused() &&
                !callStore.getIsAvatarThinking()
              "
            >
              <div class="bars speaking">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
              </div>
            </div>
            <div
              class="video-status"
              *ngIf="
                callStore.getIsAvatarThinking() &&
                !callStore.getIsAvatarSpeaking()
              "
            >
              <div class="loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userVideonew>
  <div
    class="user-video"
    [class.speaking-border]="
      playerService?.isLoopActive &&
      !callStore.getIsPaused() &&
      callStore.getIsMicOn() &&
      !playerService?.isWaitingConversationalResponse &&
      !callStore.getIsSendingAnswer()
    "
  >
    <video id="user-video" muted></video>
    <div class="user-info">
      <div
        class="microphone-muted"
        *ngIf="!callStore.getIsMicOn()|| callStore.getIsPaused()"
      >
        <img
          src="assets/icons/microphone-off-01-red.svg"
          alt="{{'call.MICROPHONE_MUTED' | transloco}}"
        />
      </div>
      <div id="video-user-name" class="video-name">{{ userName }}</div>
    </div>
    <div
      class="initials"
      *ngIf="
        callStore.getIsPaused()||
        deviceSettingsService?.isCameraUnavailable ||
        !controlService?.isVideoOn
      "
    >
      <span>
        {{ controlService?.initials }}
      </span>
    </div>
    <div
      class="video-status"
      *ngIf="
        callStore.getIsMicOn() &&
        playerService?.isLoopActive &&
        !callStore.getIsPaused() &&
        !playerService?.isWaitingConversationalResponse &&
        !callStore.getIsSendingAnswer() &&
        deviceSettingsService?.isUserSpeaking
      "
    >
      <div class="bars speaking">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #visualAidContainer>
  <img [src]="imgArray[currentPage]" />
</ng-template>

<ng-template #showVisualAidBtn>
  <div class="visual-aid-btn" data-testId="visual-aid">
    <quant-button
      type="button"
      [label]="'Display visual aid'"
      hierarchy="secondary-color"
      [iconLeading]="'assets/icons/eye.svg'"
      size="lg"
      (onClick)="toggleVisualAd()"
      [disabled]="!enableVisualAid"
    >
    </quant-button>
  </div>
</ng-template>

<ng-template #hideVisualAidBtn>
  <div class="hide-visual-aid-btn" data-testId="visual-aid">
    <quant-button
      type="button"
      [label]="'Close visual aid'"
      hierarchy="secondary-color"
      [iconLeading]="'assets/icons/closed-eye.svg'"
      size="sm"
      (onClick)="toggleVisualAd()"
    >
    </quant-button>
  </div>
</ng-template>

<ng-template #controls>
  <div class="container">
    <img
      (click)="previous()"
      [ngClass]="{ disabled: currentPage === 0 }"
      src="assets/icons/arrow-left-white.svg"
    />
    <span
      >{{ imgArray.length > 0 ? currentPage + 1 : 0 }} of
      {{ visualAid?.fileCount }}</span
    >
    <img
      (click)="next()"
      [ngClass]="{ disabled: currentPage === imgArray.length - 1 }"
      src="assets/icons/arrow-right-white.svg"
    />
  </div>
</ng-template>
